<template lang="pug">
  b-form.user-create-edit-form(@submit.stop.prevent="onSubmit" novalidate)
    b-row(cols="1" cols-md="2")
      b-col
        b-form-group(
          label="Nombre"
          label-for="name-input"
        )
          b-form-input(
            v-model="form.name"
            :state="$v.$dirty ? !$v.form.name.$invalid : null"
            id="name-input"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.name.required") Este campo es requerido
      b-col
        b-form-group(
          label="Apellido"
          label-for="last-name-input"
        )
          b-form-input(
            v-model="form.lastName"
            id="name-input"
          )
      b-col
        b-form-group(
          label="Email"
          label-for="email-input"
        )
          b-form-input(
            v-model="form.email"
            :state="$v.$dirty ? !$v.form.email.$invalid && !emailAlreadyExists : null"
            id="email-input"
            type="email"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.email.required") Este campo es requerido
            b-form-invalid-feedback(:state="$v.form.email.email") Debe ser un email válido
            b-form-invalid-feedback(:state="!emailAlreadyExists") El email ya existe
      b-col
        b-form-group(
          label="Rol"
          label-for="role-input"
        )
          b-form-select(
            v-model="form.role"
            :state="$v.$dirty ? !$v.form.role.$invalid : null"
            id="role-input"
            :options="getRoleOptions()"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.role.required") Este campo es requerido
      b-col
        b-form-group(
          :label="editMode?'Nueva contraseña (opcional)':'Contraseña'"
          label-for="password-input"
        )
          b-form-input(
            v-model="form.password"
            :state="$v.$dirty ? !$v.form.password.$invalid : null"
            id="password-input"
            type="password"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.password.required") Este campo es requerido
            b-form-invalid-feedback(:state="$v.form.password.minLength") 
              | La contraseña debe tener {{$v.form.password.$params.minLength.min}} o más caracteres
      b-col
        b-form-group(
          label="Repite la contraseña"
          label-for="repeat-password-input"
        )
          b-form-input(
            v-model="form.repeatPassword"
            :state="$v.$dirty ? !$v.form.repeatPassword.$invalid : null"
            id="repeat-password-input"
            type="password"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.repeatPassword.sameAsPassword") La contraseña no coinciden
    b-form-checkbox(v-if="form.role === 'collaborator'" v-model="form.allowCalendarView") Permitir ver calendario
    .modal-footer
      b-btn(@click="$emit('cancel')" variant="outline-muted") Cancelar
      b-btn.btn-create(type="submit") {{editMode?'Editar':'Crear'}}
</template>

<script>
import { required, email, minLength, sameAs	} from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import userRoles from '../../shared/user_roles.json'

export default {
  props: {
    editMode: Boolean,
    user: Object
  },
  data () {
    return {
      form: {
        name: '',
        lastName: '',
        email: '',
        role: userRoles[0].role,
        password: '',
        repeatPassword: '',
        allowCalendarView: false
      },
      emailAlreadyExists: false
    }
  },
  validations () {
    let validations = {
      form: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        role: {
          required
        },
        password: { 
          minLength: minLength(6)
        },
        repeatPassword: {
          sameAsPassword: sameAs('password')
        }
      }
    }
    if (!this.editMode) {
      // Validacion de contraseña al crear usuario
      validations.form.password = { 
        minLength: minLength(6),
        required
      }
    }
    return validations
  },
  methods: {
    ...mapActions('UserStore', ['createUser', 'updateUser']),
    async onSubmit () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else if (this.editMode){
        // Edita usuario existente
        let payload = this.form
        if (payload.password === '') {
          delete payload.password
        }
        const response = await this.updateUser(this.form)
        if (!response) { 
          // Error al editar usuario
          this.emailAlreadyExists = true
          this.$v.$touch()
        } else {
          // Usuario editado correctamente
          this.emailAlreadyExists = false
          this.$v.$reset()
          this.$emit('success', 'El usuario ha sido editado exitosamente')
        }
      } else {
        // Crea un nuevo usuario
        const response = await this.createUser(this.form)
        console.log(response)
        if (response.status >= 400) { 
          // Error al crear usuario
          if (response.data.detail.email) {
            this.emailAlreadyExists = true
            this.$v.$touch()
          } else {  
            this.$root.$bvToast.toast(response.data.message, {
              title: 'Oops!',
              variant: 'danger'
            })
          }
        } else {
          // Usuario creado correctamente
          this.emailAlreadyExists = false
          this.$v.$reset()
          this.$emit('success', 'El usuario ha sido creado exitosamente')
        }
      }
    },
    getRoleOptions () {
      const roleOptions = []
      this.roles.forEach(option => {
        const { role: value, name: text } = option
        roleOptions.push({ value, text})
      })
      return roleOptions
    }
  },
  computed: {
    roles () {
      return userRoles.reduce((acum, role) => 
        role.role !== 'client' ? acum.concat(role) : acum, [])
    }
  },
  created () {
    if (this.editMode) {
      this.form = {
        password: '',
        repeatPassword: '',
        ...this.user
      }
    }
  }
}
</script>
